import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CartTale2";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";

function LowInventoryReport() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "Ingredient(Code)",
      accessorKey: "Ingredient(Code)",
    },
    {
      header: "Category",
      accessorKey: "Category",
    },

    {
      header: "Stock Qty/Amount",
      accessorKey: "Stock Qty/Amount",
    },
    {
      header: "Alert Qty/Amount",
      accessorKey: "Alert Qty/Amount",
    },
    
  ]);
  const [data] = useState([]);
  const [buttonDataa] = useState([
    {
      buttonText: "Back",
    },
  ]);

  
  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={"Alert Inventory"}
        buttonDataa={buttonDataa}
        // selectButton={selectButton}
      />
    </main>
  );
}

export default LowInventoryReport;
